import { capitalize } from 'shared_DEPRECATED/utils';

import { showErrorToast, showSuccessToast } from 'shared/components/Toast';
import { clipboard } from 'shared/services/clipboard';

type TUseCopyToClipboard = {
  clipboardText: string;
  clipboardTextName: string;
};

export const useCopyToClipboard =
  ({ clipboardText, clipboardTextName }: TUseCopyToClipboard) =>
  async () => {
    try {
      await clipboard.copyToClipboard(clipboardText);

      showSuccessToast(`${capitalize(clipboardTextName)} copied to clipboard!`);
    } catch (e) {
      showErrorToast(
        `There's an error with copying ${clipboardTextName}. Please try again later.`
      );
    }
  };
